import { render, staticRenderFns } from "./FndRestDetail.vue?vue&type=template&id=a984c76a&"
import script from "./FndRestDetail.vue?vue&type=script&lang=js&"
export * from "./FndRestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports